module.exports = {"330111001":"富春街道","330111002":"春江街道","330111004":"鹿山街道","330111005":"东洲街道","330111006":"银湖街道","330111100":"万市镇","330111101":"洞桥镇","330111103":"渌渚镇","330111105":"永昌镇","330111108":"里山镇","330111109":"常绿镇","330111110":"场口镇","330111111":"常安镇","330111112":"龙门镇","330111115":"新登镇","330111116":"胥口镇","330111117":"大源镇","330111118":"灵桥镇","330111200":"新桐乡","330111201":"上官乡","330111204":"环山乡","330111205":"湖源乡","330111206":"春建乡","330111207":"渔山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330111.json
// module id = 873
// module chunks = 0